export default __webpack_public_path__ + "static/bookshelf-ca53dbc53d737480f6bff33379807cf9.jpg";